
import achievementsbg from '../../Assets/Home/Achievementsbg.svg'
import cert1 from '../../Assets/Home/Cert1.png'
import Certificate01 from "../../Assets/Certificate/certificate01.jpg"
import Certificate02 from "../../Assets/Certificate/Certificate02.png"

// import CertificateCard from "./CertificateCard"

const Certificates = () => {
  // const aboutsplashbg = MEDIA_URL + 'Home/OurSolutionbg.png';

  return (
    <div className=" pt-32 flex flex-col items-center gap-12 max-sm:gap-10  sm:max-xl:h-auto max-sm:h-auto  " >
      <div class="pl-5 w-[90vw] space-y-3">
        <h2 class="text-3xl font-bold text-gray-800 tracking-wide">
          Saptagon Asia at the 84th IRC Exhibition
        </h2>

        <p class="text-gray-600 leading-relaxed text-lg">
          We are proud to have participated in the 84th IRC Exhibition, where we showcased our innovative,
          sustainable, and cost-effective technologies for India's infrastructure. Our solutions are designed
          to drive growth, efficiency, and environmental responsibility in the nation's infrastructure development.
        </p>
      </div>

      <img src={achievementsbg} alt="" className='w-[50%] absolute -z-10 sm:max-xl:w-[70%] max-sm:hidden' />
      {/* <img src={aboutsplashbg} alt="About Us" className='max-sm:top-[12vh] max-sm:w-[58vw] sm:max-xl:top-[7vh] sm:max-xl:w-[30vw] max-sm:left-[25vw] w-[18vw] top-[16.5vh] absolute -z-10' /> */}
      <p className="max-sm:text-3xl text-4xl darkblue font-semibold">Our <span className="purple">Certifications</span> </p>

      <div className="max-sm:flex-col flex items-start text-center justify-center gap-44 sm:max-xl:gap-10 max-sm:gap-20 px-20 max-sm:px-10">

        <div className="max-sm:w-full sm:max-xl:w-full w-[30%] flex flex-col items-center gap-4 max-sm:gap-6">
          <img src={Certificate01} alt="Certificate1" className="max-sm:w-full sm:max-xl:w-full w-[90%]" />
          <p className="max-sm:w-full w-[80%] text-xl font-semibold darkblue">ISO Cetificate</p>
        </div>

        <div className="max-sm:w-full sm:max-xl:w-full w-[30%] flex flex-col items-center gap-4 max-sm:gap-6">
          <img src={Certificate02} alt="Certificate1" className="max-sm:w-full sm:max-xl:w-full w-[90%]" />
          <p className="max-sm:w-full w-[80%] text-xl font-semibold darkblue">NABL Cetificate</p>
        </div>

       


      </div>
    </div>
  )
}

export default Certificates